<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()">Nueva Pregunta</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol md="8">
          <CInput
            v-model="search"
            label="Buscar pregunta"
            placeholder="Escribe parte de la pregunta o descripción"
          />
        </CCol>
        <CCol md="4">
          <CSelect
            :value.sync="selectedTravelType"
            label="Tipo de viaje"
            :options="travelTypeOptions"
          />
        </CCol>
      </CRow>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="filteredItems"
        :fields="fields"
        :dark="dark"
      >
        <template #position="{item}"><td class="text-center">{{item.position}}</td></template>
        <template #type="{item}"><td class="text-center w100">{{item.type == 'text' ? 'Texto' : (item.type == 'options' ? 'Opciones' : (item.type == 'permission' ? 'Permiso' : (item.type == 'date' ? 'Fecha' : (item.type == 'file' ? 'Archivo' : (item.type == 'number' ? 'Numérico' : 'N/A')))))}}</td></template>
        <template #question="{item}"><td class="text-left"><strong>{{item.question}} <span style="color: red;" v-if="item.is_required">*</span></strong><br />{{item.description}}</td></template>
        <template #options="{item}"><td class="text-left w400" style="vertical-align: middle;"><span v-if="item.optionsLabels"><ul style="margin: 0px;"><li v-for="option in item.optionsLabels">{{option}}</li></ul></span></td></template>
        <template #travel_types="{item}"><td class="text-left"><span v-for="travelType in item.travel_types" :key="travelType" class="badge badge-light mr-1">{{travelTypeLabel(travelType)}}</span></td></template>
        <template #actions="{item}">
          <td class="table_actions">
            <CButton color="secondary" size="sm" :disabled="!canMove(item, -1)" @click="moveQuestion(item, -1)" v-c-tooltip="{content: 'Subir', placement: 'top'}"><CIcon name="cil-chevron-top"/></CButton>
            <CButton color="secondary" size="sm" :disabled="!canMove(item, 1)" @click="moveQuestion(item, 1)" v-c-tooltip="{content: 'Bajar', placement: 'top'}"><CIcon name="cil-chevron-bottom"/></CButton>
            <CButton color="warning" size="sm" @click="updateModal(item)"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import ws from '../../services/questions';
import store from '../../store'

export default {
  name: 'QuestionsTable',
  components: { },
  props: {
    special: 0,
    items: Array,
    permissions: Array,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: 'Orden', _style: 'width: 70px'},
          {key: 'type', label: 'Tipo'},
          {key: 'question', label: 'Pregunta'},
          {key: 'options', label: 'Opciones'},
          {key: 'travel_types', label: 'Predeterminada en'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      search: '',
      selectedTravelType: '',
      travelTypeOptions: [
        {label: 'Todos', value: ''},
        {label: 'Nacional', value: 'national'},
        {label: 'Estados Unidos', value: 'usa'},
        {label: 'Canadá', value: 'canada'},
        {label: 'Internacional', value: 'international'}
      ]
    }
  },
  computed: {
    filteredItems() {
      const search = this.normalizeText(this.search);
      const orderedItems = [...this.items].sort((first, second) => first.position - second.position);
      const itemsByTravelType = this.selectedTravelType
        ? orderedItems.filter(item => (item.travel_types || []).includes(this.selectedTravelType))
        : orderedItems;

      if(!search){
        return itemsByTravelType;
      }

      return itemsByTravelType.filter(item => this.normalizeText([
        item.question,
        item.description,
        item.options
      ].filter(Boolean).join(' ')).includes(search));
    }
  },
  methods: {
    normalizeText(value) {
      return String(value || '').toLocaleLowerCase('es-MX').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    canMove(item, direction) {
      const orderedItems = [...this.items].sort((first, second) => first.position - second.position);
      const index = orderedItems.findIndex(question => question.id == item.id);
      const targetIndex = index + direction;

      return index >= 0 && targetIndex >= 0 && targetIndex < orderedItems.length;
    },
    async moveQuestion(item, direction) {
      if(!this.canMove(item, direction)){
        return;
      }

      const orderedItems = [...this.items].sort((first, second) => first.position - second.position);
      const itemIndex = orderedItems.findIndex(question => question.id == item.id);
      const targetIndex = itemIndex + direction;

      [orderedItems[itemIndex], orderedItems[targetIndex]] = [orderedItems[targetIndex], orderedItems[itemIndex]];

      this.loading();
      const response = await ws.reorder(orderedItems.map(question => question.id));

      if(response.type == "success"){
        this.$emit("reorder");
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    travelTypeLabel(travelType) {
      return {
        national: 'Nacional',
        usa: 'Estados Unidos',
        canada: 'Canadá',
        international: 'Internacional'
      }[travelType] || travelType;
    },
    storeModal () {
      this.$emit("storeModal", this.special);
    },
    updateModal (item) {
      this.$emit("updateModal", this.special, item);
    },
    deleteModal (item) {
      this.$emit("deleteModal", this.special, item);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete({id: id});
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    showPermissionName(permission_code){
      let perm = this.$findElementByCode(this.permissions, permission_code);
      return perm ? perm.name : '';
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
